import React from 'react';
import Modal from 'react-bootstrap/Modal';

import LoaderComponent from '@components/LoaderComponent';

const PlaceOrderConfirmation = ({ orderStyles, handleClose, show, isPlacingOrder, onPlaceOrder }) => {
	const getTotal = (items) => {
		return items.reduce((total, pair) => {
			if (pair.quantity) {
				return total + parseInt(pair.quantity);
			}
			return total;
		}, 0);
	};
	const getDesignWiseBuyerPrice = (price) => {
		if (isNaN(price)) {
			return null;
		}
		return price;
	};
	const getColorWisePrice = (colorWisePrices, id) => {
		if (colorWisePrices && colorWisePrices[id]) {
			return colorWisePrices[id];
		}
		return null;
	};

	const getTotalUnits = () => {
		let total = 0;
		orderStyles.forEach((item) => {
			if (item.buyerQuotationType === 'DESIGNWISE') {
				item.colorWiseSizeQuantityPairList.map((value) => {
					total = total + getTotal(value.sizeQuantityPairList);
				});
			}
			if (item.buyerQuotationType === 'COLORWISE') {
				let itemTotal = 0;
				item.colorWiseSizeQuantityPairList.map((value) => {
					itemTotal = getTotal(value.sizeQuantityPairList);
					total = total + itemTotal;
				});
			}
			if (item.buyerQuotationType === 'SIZEWISE') {
				let sizeWiseTotal = {};
				item.colorWiseSizeQuantityPairList.map((colorObject) => {
					colorObject.sizeQuantityPairList.map((sizeObject) => {
						if (!sizeWiseTotal[sizeObject.id]) {
							sizeWiseTotal[sizeObject.id] = sizeObject.quantity;
						} else {
							sizeWiseTotal[sizeObject.id] = sizeWiseTotal[sizeObject.id] + sizeObject.quantity;
						}
					});
				});

				for (let key in sizeWiseTotal) {
					if (sizeWiseTotal[key]) {
						total = total + sizeWiseTotal[key];
					}
				}
			}
		});
		return total;
	};
	const getTotalValues = () => {
		let total = 0;
		orderStyles.forEach((item) => {
			if (item.buyerQuotationType === 'DESIGNWISE') {
				item.colorWiseSizeQuantityPairList.map((value) => {
					total =
						total +
						getTotal(value.sizeQuantityPairList) *
							getDesignWiseBuyerPrice(item.designWiseBuyerPrice);
				});
			}
			if (item.buyerQuotationType === 'COLORWISE') {
				let itemTotal = 0;
				let price;
				item.colorWiseSizeQuantityPairList.map((value) => {
					itemTotal = getTotal(value.sizeQuantityPairList);
					price = getColorWisePrice(item.colorWiseBuyerPrice, value.id);
					total = total + itemTotal * price;
				});
			}
			if (item.buyerQuotationType === 'SIZEWISE') {
				let price;
				let sizeWiseTotal = {};
				item.colorWiseSizeQuantityPairList.map((colorObject) => {
					colorObject.sizeQuantityPairList.map((sizeObject) => {
						if (!sizeWiseTotal[sizeObject.id]) {
							sizeWiseTotal[sizeObject.id] = sizeObject.quantity;
						} else {
							sizeWiseTotal[sizeObject.id] = sizeWiseTotal[sizeObject.id] + sizeObject.quantity;
						}
					});
				});

				for (let key in sizeWiseTotal) {
					if (sizeWiseTotal[key] > 0 && item.sizeWiseBuyerPrice && item.sizeWiseBuyerPrice[key]) {
						price = item.sizeWiseBuyerPrice[key];
						total = total + sizeWiseTotal[key] * price;
					}
				}
			}
		});
		return Number.isInteger(total) ? total : parseFloat(total).toFixed(2);
	};
	return (
		<div>
			<Modal show={show} onHide={handleClose} centered>
				<LoaderComponent loading={isPlacingOrder}>
					<div className="common-popup placing-order-popup shadow-24dp">
						<Modal.Header closeButton>
							<h3 className="semibold-16 mb-0">Are you sure about placing the order?</h3>
						</Modal.Header>
						<Modal.Body>
							<div className="common-popup-body">
								<div className="order-summary">
									<div className="summary-heading">
										<h3>Order summary</h3>
									</div>
									<div className="summary-details d-flex justify-content-between">
										<div className="one-third">
											<h3>{orderStyles.length}</h3>
											<p className="regular-14 gray_dark_02">
												{orderStyles.length === 1 ? 'Design' : 'Designs'}
											</p>
										</div>
										<div className="one-third">
											<h3>{getTotalUnits()}</h3>
											<p className="regular-14 gray_dark_02">Unit</p>
										</div>
										<div className="one-third">
											<h3>${getTotalValues()}</h3>
											<p className="regular-14 gray_dark_02">Value</p>
										</div>
									</div>
								</div>
							</div>
						</Modal.Body>
						<Modal.Footer>
							<div className="footer-buttons text-right">
								<button className="button outline size32" onClick={() => handleClose()}>
									Cancel
								</button>
								<button
									className="button size32 ml-2"
									disabled={isPlacingOrder}
									onClick={() => onPlaceOrder()}
								>
									Place order
								</button>
							</div>
						</Modal.Footer>
					</div>{' '}
				</LoaderComponent>
			</Modal>
		</div>
	);
};
export default PlaceOrderConfirmation;
